module.exports = __webpack_public_path__ + "img/sv9.f5d9e583.svg";